var _mask, _path, _path2, _mask2, _g, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 0.555664,
    y: 0,
    width: 33,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.555664,
    width: 33,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95566 2H10.5557V5.2H23.3557V2H24.9557V5.2H29.3557C30.4602 5.2 31.3557 6.09543 31.3557 7.2V11.6H2.55566V7.2C2.55566 6.09543 3.45109 5.2 4.55566 5.2H8.95566V2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95566 2H10.5557V5.2H23.3557V2H24.9557V5.2H29.3557C30.4602 5.2 31.3557 6.09543 31.3557 7.2V11.6H2.55566V7.2C2.55566 6.09543 3.45109 5.2 4.55566 5.2H8.95566V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5557 2H12.0557V0.5H10.5557V2ZM8.95566 2V0.5H7.45566V2H8.95566ZM10.5557 5.2H9.05567V6.7H10.5557V5.2ZM23.3557 5.2V6.7H24.8557V5.2H23.3557ZM23.3557 2V0.5H21.8557V2H23.3557ZM24.9557 2H26.4557V0.5H24.9557V2ZM24.9557 5.2H23.4557V6.7H24.9557V5.2ZM31.3557 11.6V13.1H32.8557V11.6H31.3557ZM2.55566 11.6H1.05566V13.1H2.55566V11.6ZM8.95566 5.2V6.7H10.4557V5.2H8.95566ZM10.5557 0.5H8.95566V3.5H10.5557V0.5ZM12.0557 5.2V2H9.05567V5.2H12.0557ZM23.3557 3.7H10.5557V6.7H23.3557V3.7ZM24.8557 5.2V2H21.8557V5.2H24.8557ZM23.3557 3.5H24.9557V0.5H23.3557V3.5ZM23.4557 2V5.2H26.4557V2H23.4557ZM29.3557 3.7H24.9557V6.7H29.3557V3.7ZM32.8557 7.2C32.8557 5.267 31.2887 3.7 29.3557 3.7V6.7C29.6318 6.7 29.8557 6.92386 29.8557 7.2H32.8557ZM32.8557 11.6V7.2H29.8557V11.6H32.8557ZM2.55566 13.1H31.3557V10.1H2.55566V13.1ZM1.05566 7.2V11.6H4.05566V7.2H1.05566ZM4.55566 3.7C2.62267 3.7 1.05566 5.26701 1.05566 7.2H4.05566C4.05566 6.92386 4.27952 6.7 4.55566 6.7V3.7ZM8.95566 3.7H4.55566V6.7H8.95566V3.7ZM7.45566 2V5.2H10.4557V2H7.45566Z",
    fill: "#797979",
    mask: "url(#path-1-outside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 15,
    width: 32,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 35.5C1.89543 35.5 1 34.6046 1 33.5V15H33V30.1671L22.8343 20.0014H16V26.8357L24.6643 35.5H3Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2",
    maskUnits: "userSpaceOnUse",
    x: 0.555664,
    y: 14.3984,
    width: 33,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.555664,
    y: 14.3984,
    width: 33,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55566 31.9984C2.55566 33.103 3.45109 33.9984 4.55566 33.9984H29.3557C30.4602 33.9984 31.3557 33.103 31.3557 31.9984V16.3984H2.55566V31.9984Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.55566 31.9984C2.55566 33.103 3.45109 33.9984 4.55566 33.9984H29.3557C30.4602 33.9984 31.3557 33.103 31.3557 31.9984V16.3984H2.55566V31.9984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3557 16.3984H32.8557V14.8984H31.3557V16.3984ZM2.55566 16.3984V14.8984H1.05566V16.3984H2.55566ZM4.55566 35.4984H29.3557V32.4984H4.55566V35.4984ZM32.8557 31.9984V16.3984H29.8557V31.9984H32.8557ZM31.3557 14.8984H2.55566V17.8984H31.3557V14.8984ZM1.05566 16.3984V31.9984H4.05566V16.3984H1.05566ZM29.3557 35.4984C31.2887 35.4984 32.8557 33.9314 32.8557 31.9984H29.8557C29.8557 32.2746 29.6318 32.4984 29.3557 32.4984V35.4984ZM4.55566 32.4984C4.27952 32.4984 4.05566 32.2746 4.05566 31.9984H1.05566C1.05566 33.9314 2.62267 35.4984 4.55566 35.4984V32.4984Z",
    fill: "#797979",
    mask: "url(#path-4-outside-2)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 25.8566L18.75 22.75L21.8565 22.75L33.4027 34.2961L30.2961 37.4027L18.75 25.8566Z",
    fill: "white",
    stroke: "#E57200",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0802 41.6736L37.675 39.0787C38.1083 38.6453 38.1083 37.9397 37.675 37.5063L35.6413 35.4727L31.4741 39.6399L33.5077 41.6735C33.9411 42.107 34.6468 42.107 35.0802 41.6736Z",
    fill: "#E57200"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 6,
    height: 6,
    fill: "#E57200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEdit);
export default __webpack_public_path__ + "static/media/CalendarEdit.fdebbf4ee5de7bc7403f652d0fcbb025.svg";
export { ForwardRef as ReactComponent };